export default "__VITE_ASSET__ca56ca57__"